export default __webpack_public_path__ + "static/media/1981.e01fe84a.png";